import moment from 'moment'
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams, Route } from 'react-router-dom'
import NotificationAlert from 'react-notification-alert'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from 'reactstrap'
import {
  filterGroupCourses,
  fetchAllGroups,
  setShowSelectedItems,
  setSwitchToDuration,
  setSwitchToDisabledDates,
  setHideSelectedItems,
  toggleCourse,
  togglePinToNavbar,
  onNameChange,
  toggleInactive,
  toggleDoNotAssign,
  setExpirePeriod,
  setReassignDate,
  toggleExpireDate,
  toggleLearningPlan,
  toggleAutomaticEnrollment,
  setExpirePrior,
  setExpireDate,
  setSwitchToDate,
  setTrainingDuration,
  setEquivalentGroup,
  toggleTags,
  resetGroupDetails,
  fetchGroup,
  fetchTrainigCourses,
  fetchTrainingRoles,
  fetchTrainingUsers,
  fetchGroupCourses,
  fetchGroupAssociates,
  fetchTrainingLocations,
  updateGroup,
  fetchRoles,
  fetchGroups,
  cancelSection,
  addSectionItem,
  addSection,
  onChangeSection,
  onChangeSectionItem,
  onChangeDescription,
  removeSectionItem,
  editSection,
  saveSection,
  saveDescription,
  toggleEnableReorder,
  groupCoursePositionChange,
} from 'store/Group/actions'
import { fetchUsers, fetchAssignableUsers } from 'store/Users/actions'
import { fetchStores } from 'store/Stores/actions'
// import { fetchCourseSettings } from 'store/ConfigurationSettings/CourseConfig/actions'
import ManageChecklist from '../../Course/components/checklist'
import AccessibilitySelect from '../AccessibilitySelect'
import DateRangePicker from '../../../DateRangePicker'
import Search from 'views/pages/Search'
import Select from 'views/pages/Group/Select'
import SelectedItems from 'views/pages/SelectedItems'
import './style.css'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { togglePinToNavbarDevelopment } from 'store/Group/actions'
import { deleteSection } from 'store/Group/actions'

const EditCourseGroup = (props) => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const groups = useSelector((state) => state.groups)
  const user = useSelector((state) => state.auth.user)
  const users = useSelector((state) => state.users)
  const stores = useSelector((state) => state.stores.stores)
  const notificationAlertRef = useRef(null)
  const group = useSelector((state) => state.groups.group)
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}
  const courseConfig = useSelector((state) => state.courseConfig)
  let owner = false

  const notify = (type, data) => {
    let options = {
      place: 'tc',
      message: (
        <div className='alert-text'>
          <span className='alert-title' data-notify='title'>
            {data.title && data.title}
          </span>
          <span data-notify='message'>{data.msgBody && data.msgBody}</span>
        </div>
      ),
      type: type,
      icon: 'ni ni-bell-55',
      autoDismiss: 7,
    }
    notificationAlertRef.current.notificationAlert(options)
  }
  const isChecked = (props, property, value) => {
    return props[property] && props[property].indexOf(value) !== -1
  }

  const getExpirePeriod = () => {
    switch (groups.expirePeriod) {
      case 'y':
        return 365
      case 'm':
        return 31
      case 'w':
        return 7
      case 'd':
        return 1
      default:
        break
    }
  }
  const getExpirePrior = () => {
    switch (groups.expirePrior) {
      case 'y':
        return 365
      case 'm':
        return 31
      case 'w':
        return 7
      case 'd':
        return 1
      default:
        break
    }
  }
  const expireDays = groups.expireDate * getExpirePeriod()
  const reassignDays = groups.reassignDate * getExpirePrior()
  useEffect(() => {
    dispatch(fetchUsers())
    // dispatch(fetchCourseSettings())
    dispatch(fetchAssignableUsers())
    dispatch(fetchGroups())
    dispatch(fetchAllGroups())
    dispatch(fetchRoles())
    dispatch(fetchStores())
    dispatch(fetchGroup(id))
    dispatch(fetchGroupCourses(id))
    dispatch(fetchGroupAssociates(id))
    dispatch(fetchTrainingLocations(id))
    dispatch(fetchTrainingRoles(id))
    dispatch(fetchTrainigCourses(id))
    dispatch(fetchTrainingUsers(id))

    return () => {
      dispatch(resetGroupDetails())
    }
  }, [])

  const handleLearningPlanChange = () => {
    dispatch(toggleLearningPlan(group.show_in_learning_plan ? 0 : 1))
    dispatch(togglePinToNavbarDevelopment(0))
  }
  const handleComplianceChange = () => {
    dispatch(togglePinToNavbar(groups.pinToNavbar ? 0 : 1))
    dispatch(togglePinToNavbarDevelopment(0))
  }

  const handleDevelopmentChange = () => {
    dispatch(
      togglePinToNavbarDevelopment(groups.pinToNavbarDevelopment ? 0 : 1),
    )
    dispatch(toggleLearningPlan(0))
    dispatch(togglePinToNavbar(0))
  }

  useEffect(() => {
    dispatch(togglePinToNavbarDevelopment(group.pin_to_navbar_development))
  }, [dispatch, group.pin_to_navbar_development])

  return (
    <Col className={!props.fromSettings ? 'mt--6' : ''}>
      <div className='rna-wrapper'>
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Card className='shadow-none'>
        <CardHeader className={`pb-1 ${props.fromSettings && 'px-0'}`}>
          <h2>Course Group</h2>
        </CardHeader>

        <CardBody className={`${props.fromSettings && 'px-0'}`}>
          {group.updated_at && group.updated_by_user ? (
            <label className='latest-update'>
              Last Changed
              {' ' + moment(group.updated_at).format('MM/DD/YY hh:mm')}{' '}
              discussions by
              {' ' + group.updated_by_user.username}
            </label>
          ) : null}
          <Row>
            <Col xs='12' lg='6'>
              <h4>
                {language.settings ? language.settings.group_title : null}:
              </h4>
              <Input
                id='example-text-input'
                bsSize='sm'
                className='mb-2 font-weight-bold text-dark'
                type='text'
                value={(group && group.name) || ''}
                onChange={(e) => dispatch(onNameChange(e.target.value))}
                disabled={user.access === 1 || owner ? false : true}
              />
              <div className='custom-control custom-checkbox-info mb-1'>
                <input
                  className='custom-control-input'
                  id='showInLearningPlan'
                  type='checkbox'
                  checked={group && group.show_in_learning_plan}
                  // onChange={() =>
                  //   dispatch(
                  //     toggleLearningPlan(
                  //       group && group.show_in_learning_plan ? 0 : 1
                  //     )
                  //   )
                  // }
                  onChange={handleLearningPlanChange}
                />
                <label
                  className='custom-control-label'
                  htmlFor='showInLearningPlan'
                  style={{ fontSize: '14px' }}
                >
                  {language.settings
                    ? language.settings.show_in_learning_plan
                    : null}
                </label>
              </div>
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='doNotAssign'
                    type='checkbox'
                    checked={groups.doNotAssign}
                    onChange={() => dispatch(toggleDoNotAssign())}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='doNotAssign'
                    style={{ fontSize: '14px' }}
                  >
                    {language.groups ? language.groups.do_not_assign : null}
                  </label>
                </div>
              ) : null}
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='assignNewEmployee'
                    type='checkbox'
                    checked={groups.automaticEnrollment}
                    onChange={() => dispatch(toggleAutomaticEnrollment())}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='assignNewEmployee'
                    style={{ fontSize: '14px' }}
                  >
                    {language.settings
                      ? language.settings.assign_new_employees_automatically
                      : null}
                  </label>
                </div>
              ) : null}
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='showInCompliance'
                    type='checkbox'
                    checked={groups.pinToNavbar}
                    onChange={handleComplianceChange}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='showInCompliance'
                    style={{ fontSize: '14px' }}
                  >
                    {language.settings
                      ? language.settings.show_in_compliance
                      : null}
                  </label>
                </div>
              ) : null}

              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='showInDevelopment'
                    type='checkbox'
                    checked={groups.pinToNavbarDevelopment}
                    onChange={handleDevelopmentChange}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='showInDevelopment'
                    style={{ fontSize: '14px' }}
                  >
                    {language?.settings?.show_in_development ||
                      'Show in development'}
                  </label>
                </div>
              ) : null}
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='enableReorder'
                    type='checkbox'
                    checked={groups.enableReorder || false}
                    onChange={() => dispatch(toggleEnableReorder())}
                  />
                  <label
                    className='custom-control-label'
                    style={{ fontSize: '14px' }}
                    htmlFor='enableReorder'
                  >
                    Enable Chain Assignment
                  </label>
                </div>
              ) : null}
              {[1].includes(user.access) ? (
                <div className='custom-control custom-checkbox-info mb-1'>
                  <input
                    className='custom-control-input'
                    id='inactive'
                    type='checkbox'
                    checked={groups.inactive || false}
                    onChange={() => dispatch(toggleInactive())}
                  />
                  <label
                    className='custom-control-label'
                    style={{ fontSize: '14px' }}
                    htmlFor='inactive'
                  >
                    {language.general ? language.general.inactive : null}
                  </label>
                </div>
              ) : null}
              <FormGroup className='mt-5 ml-0'>
                <label
                  style={{ fontSize: '15px' }}
                  className='form-control-label'
                  htmlFor='exampleFormControlSelect1'
                >
                  {language.groups ? language.groups.equivalent_group : null}:
                </label>
                <Select
                  options={groups.allGroups.filter(
                    (item) => item.id !== groups.group.id,
                  )}
                  placeholder={
                    language.groups
                      ? language.groups.add_equivalent_group
                      : null
                  }
                  selectedOptions={groups.equivalentGroup}
                  onChange={(e) => dispatch(setEquivalentGroup(e))}
                  multi={false}
                  valueKey={'id'}
                  clearable={true}
                />
              </FormGroup>
            </Col>
            <Col>
              <h4>
                {language.groups ? language.groups.expiration_type : null}:
              </h4>
              <Row className='col-12  align-items-center'>
                <div className='custom-control custom-radio mb-3 mr-4'>
                  <input
                    className='custom-control-input'
                    defaultChecked
                    id='date'
                    type='radio'
                    name='date'
                    checked={groups.hasDate || null}
                    onChange={() => dispatch(setSwitchToDate())}

                    // onChange={dateType}
                  />
                  <label className='custom-control-label' htmlFor='date'>
                    {language.groups ? language.groups.date : null}
                  </label>
                </div>
                <div className='custom-control custom-radio mb-3 mr-4'>
                  <input
                    className='custom-control-input'
                    id='duration'
                    name='date'
                    type='radio'
                    checked={groups.hasDuration || null}
                    onChange={() => dispatch(setSwitchToDuration())}
                  />
                  <label className='custom-control-label' htmlFor='duration'>
                    {language.groups ? language.groups.group_length : null}
                  </label>
                </div>
                <div className='custom-control custom-radio mb-3 mr-4'>
                  <input
                    className='custom-control-input'
                    id='disable-dates'
                    name='date'
                    type='radio'
                    checked={groups.datesDisabled || null}
                    onChange={() => dispatch(setSwitchToDisabledDates())}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor='disable-dates'
                  >
                    {language.settings ? language.settings.disable_dates : null}
                  </label>
                </div>

                {courseConfig &&
                courseConfig.enableCourseGroupChecklist &&
                parseInt(courseConfig.enableCourseGroupChecklist) === 1 ? (
                  <div className='ml-2' style={{ margin: '10px' }}>
                    <Link
                      className='btn btn-info py-2 mt--3 d-block checklistBtn'
                      to={
                        props.fromSettings
                          ? `/settings/groups/courses/${id}/checklist`
                          : `/group/${id}/edit/checklist`
                      }
                    >
                      {'Checklist'}
                    </Link>
                  </div>
                ) : null}
                <Route
                  path={
                    props.fromSettings
                      ? `/settings/groups/courses/${id}/checklist`
                      : `/group/${id}/edit/checklist`
                  }
                  render={(routeProps) => (
                    <ManageChecklist
                      {...routeProps}
                      {...groups}
                      backPath={
                        props.fromSettings
                          ? `/settings/groups/courses/${props.match.params.id}`
                          : `/group/${props.match.params.id}/edit`
                      }
                      cancelSection={() => dispatch(cancelSection())}
                      addSectionItem={() => dispatch(addSectionItem())}
                      addSection={() => dispatch(addSection())}
                      onChangeSection={(event) =>
                        dispatch(onChangeSection(event))
                      }
                      onChangeSectionItem={(event) =>
                        dispatch(onChangeSectionItem(event))
                      }
                      onChangeDescription={(name, value) =>
                        dispatch(onChangeDescription(name, value))
                      }
                      removeSectionItem={(index) =>
                        dispatch(removeSectionItem(index))
                      }
                      editSection={(index) => dispatch(editSection(index))}
                      deleteSection={(index) => dispatch(deleteSection(index))}
                      saveSection={() => dispatch(saveSection())}
                      saveDescription={() => dispatch(saveDescription())}
                      language={language}
                    />
                  )}
                />
              </Row>
              {!groups.datesDisabled ? (
                groups.hasDuration ? (
                  <div className='input-default-row'>
                    <label className='assignment-rating-label' htmlFor='length'>
                      Duration:
                    </label>
                    <input
                      className='gen-form-text-input days-nr side-margin-input'
                      type='text'
                      name='group_length'
                      onChange={(e) => dispatch(setTrainingDuration(e))}
                      value={groups.duration || ''}
                    ></input>
                    <label className='assignment-rating-label' htmlFor='length'>
                      {/* {language.groups ? language.groups.days : null} */}
                      Days
                    </label>
                  </div>
                ) : (
                  <FormGroup>
                    <label
                      className='form-control-label'
                      htmlFor='example-date-input'
                      md='2'
                    >
                      Date
                    </label>
                    <DateRangePicker
                      {...groups}
                      startDate={groups.startDate}
                      endDate={groups.endDate}
                      className='side-margin-input'
                    />
                  </FormGroup>
                )
              ) : null}
              {!groups.hasDate ? (
                <div>
                  <div className='custom-control custom-checkbox-info mb-4'>
                    <input
                      className='custom-control-input'
                      id='expire-date'
                      type='checkbox'
                      checked={groups.hasExpireDate || false}
                      onChange={() => dispatch(toggleExpireDate())}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor='expire-date'
                      style={{ fontSize: '14px' }}
                    >
                      {/* {language.groups ? language.groups.enable_expire_settings : null} */}
                      {language.groups
                        ? language.groups.enable_expire_settings
                        : null}
                    </label>
                  </div>

                  {groups.hasExpireDate ? (
                    <div className='col-lg-6 px-0'>
                      <div className='d-flex align-items-center justify-content-between'>
                        <label
                          style={{
                            fontSize: '14px',
                          }}
                        >
                          {/* {language.groups ? language.groups.expires_in : null}: */}
                          Expires in:
                        </label>
                        <div className='d-flex justify-content-end'>
                          <input
                            className='gen-form-text-input days-nr side-margin-input'
                            type='text'
                            name='expire-date-value'
                            value={groups.expireDate || ''}
                            onChange={(e) => dispatch(setExpireDate(e))}
                          />
                          <select
                            className='btn btn-info p-0'
                            style={{
                              height: '35px',
                              width: '100px',
                            }}
                            name='expire-date-select'
                            value={groups.expirePeriod || ''}
                            onChange={(e) => dispatch(setExpirePeriod(e))}
                          >
                            <option className='bg-white text-default' value='d'>
                              Days
                            </option>
                            <option className='bg-white text-default' value='w'>
                              Weeks
                            </option>
                            <option className='bg-white text-default' value='m'>
                              Months
                            </option>
                            <option className='bg-white text-default' value='y'>
                              Years
                            </option>
                          </select>
                        </div>
                      </div>
                      <br />
                      <div className='d-flex align-items-center justify-content-between'>
                        <label
                          style={{
                            fontSize: '14px',
                          }}
                        >
                          {/* {language.groups ? language.groups.reassign : null}:{" "} */}
                          Reassign:
                        </label>
                        <div className='d-flex justify-content-end'>
                          <input
                            className='gen-form-text-input days-nr side-margin-input'
                            type='text'
                            name='expire-date-value'
                            value={groups.reassignDate || ''}
                            onChange={(e) => dispatch(setReassignDate(e))}
                          />
                          <select
                            className='btn btn-info btn-has-dropdown p-0'
                            name='expire-date-select'
                            style={{
                              height: '35px',
                              width: '100px',
                            }}
                            value={groups.expirePrior || ''}
                            onChange={(e) => dispatch(setExpirePrior(e))}
                          >
                            <option className='bg-white text-default' value='d'>
                              Days
                            </option>
                            <option className='bg-white text-default' value='w'>
                              Weeks
                            </option>
                            <option className='bg-white text-default' value='m'>
                              Months
                            </option>
                            <option className='bg-white text-default' value='y'>
                              Years
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </Col>
          </Row>
          <hr />
          <Row>
            <Col xs='12' lg='6'>
              <h4>{language.settings ? language.settings.tags : null}:</h4>

              {(() => {
                let tagsDetails = []
                if (JSON.stringify(groups.tags) === JSON.stringify(['1'])) {
                  tagsDetails = [
                    {
                      name: 'Core Training',
                      value: '1',
                    },
                  ]
                } else if (
                  JSON.stringify(groups.tags) === JSON.stringify(['2'])
                ) {
                  tagsDetails = [
                    {
                      name: 'Initiative Training',
                      value: '2',
                    },
                  ]
                } else if (
                  JSON.stringify(groups.tags) === JSON.stringify(['1', '2']) ||
                  JSON.stringify(groups.tags) === JSON.stringify(['2', '1'])
                ) {
                  tagsDetails = [
                    {
                      name: 'Core Training',
                      value: '1',
                    },
                    {
                      name: 'Initiative Training',
                      value: '2',
                    },
                  ]
                } else {
                  tagsDetails = []
                }

                const tagInfo = [
                  { name: 'Core Training', value: '1' },
                  {
                    name: 'Initiative Training',
                    value: '2',
                  },
                ]

                return (
                  <FormGroup className='ml-0'>
                    <Select
                      options={tagInfo}
                      placeholder={`${
                        language.general ? language.general.select_tags : null
                      }`}
                      selectedOptions={tagsDetails}
                      onChange={(e) => dispatch(toggleTags(e))}
                      multi={true}
                      clearable={true}
                      disabled={user.access === 1 || owner ? false : true}
                    />
                  </FormGroup>
                )
              })()}
            </Col>
            <Col>
              <h4>
                {' '}
                {language.groups ? language.groups.assign_make_available : null}
                :
              </h4>
              {(() => {
                const currentGroup = groups.manageableTrainings.find(
                  (item) => item.id === groups.group.id,
                )

                let owner = false
                let isNewGroup = id === 'new' ? true : false

                if (currentGroup && currentGroup.owner === 1) {
                  owner = true
                }

                return user.access === 1 || owner || isNewGroup ? (
                  <AccessibilitySelect
                    {...props}
                    nameHolder={
                      language.groups ? language.groups.assign_to : null
                    }
                    type={'assign'}
                    groups={groups}
                    courses={groups.trainingCourses}
                    roleGroups={groups.roleGroups}
                    stores={stores}
                    users={users}
                    roles={groups.roles}
                    doNotAssign={groups.doNotAssign}
                  />
                ) : null
              })()}
            </Col>
          </Row>
          <hr />
          <Col xs='12' lg='6' className='col-6 ml-0 pl-0'>
            <h4 className='pb-2'>
              {language.settings ? language.settings.courses : null}:
            </h4>
            <div className='d-flex justify-content-between searchInput'>
              <SelectedItems
                {...props}
                items={
                  groups.trainingCourses &&
                  groups.trainingCourses.length > 0 &&
                  groups.trainingCourses
                    .filter((item) => groups.selectedCourses.includes(item.id))
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                }
                selectedItems={groups.selectedCourses}
                setShowSelectedItems={() => dispatch(setShowSelectedItems())}
                setHideSelectedItems={() => dispatch(setHideSelectedItems())}
                showSelectedItems={groups.showSelectedItems}
                onChange={toggleCourse}
                disabled={user.access === 1 || owner ? false : true}
                style={{ padding: '6px 12px' }}
              />
              <Search
                placeholder={
                  language.settings ? language.settings.search_courses : null
                }
                value={groups.filterGroupCoursesValue}
                onChange={(e) => dispatch(filterGroupCourses(e.target.value))}
                style={{
                  padding: '6px 12px',
                  height: '35px',
                }}
              />
            </div>
            <div
              className='scrollbar p-2 overflow-auto rounded'
              style={{
                height: '300px',
                border: '1px solid #dee2e6',
              }}
            >
              {groups.trainingCourses &&
                groups.trainingCourses.length > 0 &&
                groups.trainingCourses
                  .filter(
                    (item) =>
                      item.name
                        .toLowerCase()
                        .indexOf(
                          groups.filterGroupCoursesValue.toLowerCase(),
                        ) !== -1,
                  )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((course, index) => {
                    const currentCourse =
                      groups.selectedCoursesWithPosition.find(
                        (courseItem) => courseItem.course_id == course.id,
                      )
                    const position = currentCourse ? currentCourse.position : ''
                    return (
                      <div
                        key={index}
                        style={{ paddingLeft: '.5rem' }}
                        className='custom-control dropdown-menu-arroww custom-checkbox-info mb-3'
                      >
                        <input
                          type='number'
                          placeholder='Position'
                          defaultValue={
                            isChecked(groups, 'selectedCourses', course.id)
                              ? position
                              : ''
                          }
                          onChange={(e) => {
                            if (e.target.value != '' && e.target.value < 1) {
                              e.target.value = '1'
                            }
                            dispatch(
                              groupCoursePositionChange(
                                course.id,
                                e.target.value,
                              ),
                            )
                          }}
                          style={{
                            width: '40px',
                            marginRight: '35px',
                          }}
                        />
                        <input
                          className='custom-control-input rounded'
                          id={`${index}`}
                          type='checkbox'
                          onChange={() => dispatch(toggleCourse(course.id))}
                          checked={isChecked(
                            groups,
                            'selectedCourses',
                            course.id,
                          )}
                          disabled={user.access === 1 || owner ? false : true}
                        />
                        <label
                          className='custom-control-label'
                          htmlFor={`${index}`}
                        >
                          {course.name}
                        </label>
                      </div>
                    )
                  })}
            </div>
          </Col>
          <div className='row mt-4'>
            <div className='col-12'>
              {!group.name ? (
                <>
                  <SubmitModalButton
                    customFn={() => {
                      notify('danger', {
                        title: 'Please set group name!',
                        msgBody: '',
                      })
                    }}
                  />
                </>
              ) : groups.hasExpireDate && expireDays <= reassignDays ? (
                <SubmitModalButton
                  text='Save'
                  customFn={() => {
                    notify('danger', {
                      title:
                        'Reassign Date should be less than the Expire Date!',
                      msgBody: '',
                    })
                  }}
                />
              ) : groups.assignableTrainingRoles.length &&
                !groups.assignableTrainingStores.length &&
                !groups.assignableTrainingLocationGroups.length &&
                groups.assignableTrainingRoles.length ? (
                <SubmitModalButton
                  text='Save'
                  customFn={() => {
                    notify('danger', {
                      title:
                        'Please assign the group to at least one location!',
                      msgBody: '',
                    })
                  }}
                />
              ) : (groups.assignableTrainingLocationGroups.length ||
                  groups.assignableTrainingStores.length) &&
                !groups.assignableTrainingRoles.length &&
                !groups.assignableTrainingRoleGroups.length ? (
                <SubmitModalButton
                  text='Save'
                  customFn={() => {
                    notify('danger', {
                      title:
                        'Please assign the group to at least one job title or role group!',
                      msgBody: '',
                    })
                  }}
                />
              ) : (
                <Link
                  to={
                    props.fromSettings ? '/settings/groups' : '/learning-plan'
                  }
                >
                  <SubmitModalButton
                    text='Save'
                    customFn={() => dispatch(updateGroup())}
                  />
                </Link>
              )}
              <Link
                to={props.fromSettings ? '/settings/groups' : '/learning-plan'}
              >
                <CancelModalButton
                  customFn={() => dispatch(resetGroupDetails())}
                />
              </Link>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default EditCourseGroup
